import * as React from 'react';
import { FormStore } from '../store/FormStore';
import { observer } from 'mobx-react';

export interface IFormValues {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    [key: string]: any;
}
export interface IFormProps {
    onChange(ev: React.FormEvent<HTMLInputElement>): void;
    onResponseChange(ev: React.FormEvent<HTMLInputElement>): void;
    onBlur(fieldName: string): void;
    values: IFormValues;
    getError(fieldName: string): string;
    onDropDownChange(fieldName: string, value: string): void;
    onPhoneInputChange(name: string, value: string): void;
    setFieldValidations(fieldName: string, validations?: {}): void;
    removeValidationField(fieldName: string): void;
}
export interface IContext {
    form: IFormProps;
}
export interface IFormConfig<T> {
    render?(props: IFormProps): React.ReactNode;
    children?: React.ReactNode;
    store: FormStore<T>;
}
@observer
export class Form<T> extends React.Component<IFormConfig<T>> {
    public store: FormStore<T>;
    public constructor(props: IFormConfig<T>) {
        super(props);
        this.store = props.store;
    }

    public static childContextTypes = {
        form: () => null
    };

    public getChildContext(): IContext {
        return {
            form: {
                onChange: this.onChange,
                onBlur: this.onBlur,
                values: this.store.values,
                getError: this.store.getError,
                onDropDownChange: this.onDropDownChange,
                onPhoneInputChange: this.onPhoneInputChange,
                onResponseChange: this.onResponseChange,
                setFieldValidations: this.store.setFieldValidations,
                removeValidationField: this.store.removeValidationField
            }
        };
    }

    public onChange = (ev: React.FormEvent<HTMLInputElement>) => {
        this.store.setFieldValue(
            ev.currentTarget.name as keyof T,

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            ev.currentTarget.value as any
        );
    };

    public onPhoneInputChange = (name: string, value: string): void => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.store.setFieldValue(name as keyof T, value as any);
    };

    public onBlur = (name: string) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const values = this.store.values as any;
        if (typeof values[name] === 'string') {
            // trim string values
            this.store.setFieldValue(name as keyof T, values[name].trim());
        }
        this.store.blurField(name as keyof T);
    };

    public onDropDownChange = (inputName: string, value: string): void => {
        this.store.setFieldValue(
            inputName as keyof T,

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            value as any
        );
    };

    public onResponseChange = (event: React.FormEvent<HTMLInputElement>): void => {
        const {
            currentTarget: { name, checked, value }
        } = event;

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const targetValue = value as any;

        const fieldName = name as keyof T;
        const fieldValue = checked ? targetValue : undefined;

        this.store.setFieldValue(fieldName, fieldValue);
    };

    public render() {
        const { render, children } = this.props;
        const props = {};

        return render
            ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
              (render as any)(props)
            : children
            ? typeof children === 'function'
                ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
                  (children as any)(props)
                : React.Children.count(children) !== 0
                ? React.Children.only(children)
                : null
            : null;
    }
}
